import { SCRIPT_TYPE } from "../enum/script-type.enum";
import { IScript } from "../interface/script.interface";

export const hotjarScript: IScript = {
  name: 'hotjar',
  src: `(function(h,o,t,j,a,r){
          h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
          h._hjSettings={hjid:4977113,hjsv:6};
          a=o.getElementsByTagName('head')[0];
          r=o.createElement('script');r.async=1;
          r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
          a.appendChild(r);
      })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`,
  loaded: false,
  type: SCRIPT_TYPE.inner
};
